<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="划转" name="total"></el-tab-pane>
      <el-tab-pane label="用户" name="detail"></el-tab-pane>
    </el-tabs>
    <el-card v-show="type == 'total'">
      <el-input
        v-model="coinType"
        size="mini"
        class="search"
        placeholder="输入币种搜索"
      ></el-input>
      <el-input
        v-model="userId1"
        size="mini"
        class="search"
        placeholder="用户ID"
      ></el-input>
      <el-date-picker
        v-model="dateVal1"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="mini"
        class="date-search"
      >
      </el-date-picker>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryTotalData(true)"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="contractTransfer">
        <el-table-column label="币种" prop="coinType"></el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">转入</span>
            <span v-if="scope.row.type == 2">转出</span>
            <span v-if="scope.row.type == 3">体验金转入</span>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="数额" prop="coinAmount"></el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">{{
            scope.row.createTime | moment
          }}</template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination
          :size="pager1.size"
          :page="pager1.page"
          :total="contractTransferTotal"
          @pageChanged="handlPageChanged1"
        >
        </pagination>
      </div>
    </el-card>
    <el-card v-show="type == 'detail'">
      <el-input
        v-model="userId2"
        size="mini"
        class="search"
        placeholder="用户ID"
      ></el-input>
      <el-input
        v-model="accountId"
        size="mini"
        class="search"
        placeholder="账户ID"
      ></el-input>
      <el-date-picker
        v-model="dateVal2"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="mini"
        class="date-search"
      >
      </el-date-picker>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="queryDetailData(true)"
        circle
        size="mini"
      ></el-button>
      <el-table v-if="tableAble" :data="contractUser">
        <el-table-column label="用户ID" prop="userId"></el-table-column>
        <el-table-column label="账户ID" prop="accountId"></el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">{{
            scope.row.createTime | moment
          }}</template>
        </el-table-column>
      </el-table>
      <div class="pager-wrap">
        <pagination
          :size="pager2.size"
          :page="pager2.page"
          :total="contractUserTotal"
          @pageChanged="handlPageChanged2"
        >
        </pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
import "../store.js";
import { mapState, mapActions } from "vuex";
import Pagination from "components/pagination";

import { formatTable } from "../../../common/tools.js";
export default {
  name: "dataCenterCurrent",
  data() {
    return {
      type: "total",
      coinType: "",
      dateVal1: "",
      dateVal2: "",
      userId1: "",
      userId2: "",
      pager1: {
        page: 1,
        size: 10,
      },
      pager2: {
        page: 1,
        size: 10,
      },
    };
  },
  methods: {
    ...mapActions("dataCenter", [
      "getAllCoins",
      "getContractTransfer",
      "getContractUser",
    ]),
    queryTotalData(clr) {
      if (clr) this.pager1.page = 1;
      let q = {
        page: this.pager1.page,
        size: this.pager1.size,
      };
      if (this.dateVal1) {
        q.startTime = this.dateVal1[0].getTime();
        q.endTime = this.dateVal1[1].getTime();
      }
      if (this.coinType) q.coinType = this.coinType;
      if (this.userId1) q.userId = this.userId1;
      this.getContractTransfer(q);
    },
    queryDetailData(clr) {
      if (clr) this.pager2.page = 1;
      let q = {
        page: this.pager2.page,
        size: this.pager2.size,
      };
      if (this.dateVal2) {
        q.startTime = this.dateVal2[0].getTime();
        q.endTime = this.dateVal2[1].getTime();
      }
      if (this.userId2) q.userId = this.userId2;
      if (this.accountId) q.accountId = this.accountId;
      this.getContractUser(q);
    },
    tabChange() {
      if (this.type == "total") {
        this.queryTotalData();
      } else {
        this.queryDetailData();
      }
    },
    handlPageChanged1(pagination) {
      this.pager1.page = pagination.page;
      this.pager1.size = pagination.size;
      this.queryTotalData();
    },
    handlPageChanged2(pagination) {
      this.pager2.page = pagination.page;
      this.pager2.size = pagination.size;
      this.queryDetailData();
    },
  },
  computed: {
    ...mapState("dataCenter", [
      "allCoins",
      "contractTransfer",
      "contractUser",
      "contractTransferTotal",
      "contractUserTotal",
      "tableAble"
    ]),
  },
  watch: {
    contractTransfer() {
      formatTable();
    },
    contractUser() {
      formatTable();
    },
  },
  mounted() {
    this.queryTotalData();
  },
  components: {
    Pagination,
  },
};
</script>
<style scoped>
.search {
  width: 200px;
  margin: 0px 20px 20px 0px;
}
.date-search {
  margin-right: 20px;
}
</style>
